import * as constants from "./../../constants.js";
import * as gsf from "./../../game-state-functions.js";
import clone from "../../util/clone.js";
import * as shapeSpatialRelations from "./../../geometry/shape-spatial-relations.js";
import * as cf from "./../../core-functions.js";
import { cloneCellStamps } from "../../util/cell-stamps.js";

var type = "twin";
var INITIAL_TIMELEFT = 10000;
// Hold the twin effect (and the trail-immunity it grants) for a short grace after spawn
// before the separation check may drop it. Online the twin spawns just behind the original
// - a latency artifact: the spawn point is under the original's just-laid trail - and
// dropping immunity the instant they're apart let the host kill it before it cleared the
// overlap. ~0.4s covers the immunity distance at normal speed. Offline is unaffected (the
// two diverge from the same point, so they're clear well before the grace ends).
var SPAWN_GRACE_SECONDS = 0.4;

function activate({ gameState, wormId, affects}) {
    var affectedWorms = [];

    if (affects === "self") {
        affectedWorms.push(gsf.getWorm(gameState, wormId));
    } else if (affects === "others") {
        affectedWorms = gsf.getAliveEnemyWorms(gameState, wormId);
    } else if (affects === "all") {
        affectedWorms = gsf.getAliveWorms(gameState);
    }

    affectedWorms.forEach(function (worm) {
        // A client-authoritative worm (an online human) spawns and owns its OWN twin: the
        // client picks the twin's id + spawn point, sends them (with the immunity effects)
        // to the host, and the host adopts that worm via spawnClientWorm. So the host must
        // NOT spawn a second, diverging twin here. Bots and offline play (not externally
        // controlled) still spawn their twin server-side, exactly as before.
        if (worm.externallyControlled) {
            return;
        }
        var newWorm = gsf.addWorm(gameState, gsf.createWorm(gameState, {
            playerId: worm.playerId,
            direction: worm.direction - Math.PI / 8,
            centerX: worm.centerX,
            centerY: worm.centerY,
            radius: worm.radius,
            distanceTravelled: worm.distanceTravelled,
            distanceTravelledFromCells: cloneCellStamps(worm.distanceTravelledFromCells)
        }));
        worm.direction += Math.PI / 8;
        gsf.getWormEffects(gameState, worm.id).forEach(function (effect) {
            var clonedEffect = clone(effect);
            clonedEffect.wormId = newWorm.id;
            gsf.addEffect(gameState, clonedEffect);
        });
        //TODO Instead of timeLeft, make sure the effects are removed when worm and twin-worm no longer intersect (maybe with a margin)
        gsf.addEffect(gameState, {timeLeft: INITIAL_TIMELEFT, wormId: newWorm.id, type: type, twinWormId: worm.id});
        gsf.addEffect(gameState, {timeLeft: INITIAL_TIMELEFT, wormId: worm.id, type: type, twinWormId: newWorm.id});
    });
}

function update(gameState, deltaTime, effect) {
    var worm = gsf.getWorm(gameState, effect.wormId);
    var twinWorm = gsf.getWorm(gameState, effect.twinWormId);
    // Keep the effect through the spawn grace (see SPAWN_GRACE_SECONDS) so the twin's
    // trail-immunity survives the initial overlap before the separation check can drop it.
    if (INITIAL_TIMELEFT - effect.timeLeft < SPAWN_GRACE_SECONDS) {
        return;
    }
    if (shapeSpatialRelations.distance(worm, twinWorm) >= (cf.getWormRadius(gameState, worm.id) + cf.getWormRadius(gameState, twinWorm.id) + 1)) {
        effect.timeLeft = 0;
    }
}

export {
    type,
    activate,
    update
};
